import { DropdownEditor, Field, TextEditor } from '@approvalmax/ui';
import { constants } from 'modules/common';
import { domain } from 'modules/data';
import { PlainDataProvider } from 'modules/data-providers';
import { memo } from 'react';

import { Header, Row, RowGroup } from '../../XeroCreateContactPopup.styles';
import { messages } from './TaxSection.messages';
import { TaxSectionProps } from './TaxSection.types';

const { xeroConstants } = constants;

export const TaxSection = memo<TaxSectionProps>((props) => {
    const { contact, xeroContext, qa, onChangeReferenceField, onChangeField } = props;

    return (
        <div>
            <Header>{messages.taxHeader}</Header>

            <RowGroup>
                <Row>
                    <Field title={messages.taxIdNumberLabel}>
                        <TextEditor
                            qa={qa('tax-id-number-editor')}
                            value={contact.taxNumber || ''}
                            maxLength={xeroConstants.TAX_NUMBER_MAX_LENGTH}
                            onChange={onChangeField('taxNumber')}
                            placeholder={messages.taxIdNumberPlaceholder}
                        />
                    </Field>

                    <Field title={messages.companyNumberLabel}>
                        <TextEditor
                            qa={qa('company-number-editor')}
                            value={contact.companyNumber || ''}
                            maxLength={xeroConstants.COMPANY_NUMBER_MAX_LENGTH}
                            onChange={onChangeField('companyNumber')}
                            placeholder={messages.companyNumberPlaceholder}
                        />
                    </Field>
                </Row>

                <Row>
                    <Field title={messages.salesTaxLabel}>
                        <PlainDataProvider items={xeroContext.taxCodes}>
                            <DropdownEditor
                                qa={qa('sales-tax-editor')}
                                placeholder={messages.dropdownPlaceholder}
                                value={contact.salesTax || null}
                                onChange={(newTax: domain.XeroTaxCode) => onChangeReferenceField('salesTax', newTax)}
                            />
                        </PlainDataProvider>
                    </Field>

                    <Field title={messages.purchaseTax}>
                        <PlainDataProvider items={xeroContext.taxCodes}>
                            <DropdownEditor
                                qa={qa('purchase-tax-editor')}
                                placeholder={messages.dropdownPlaceholder}
                                value={contact.purchaseTax || null}
                                onChange={(newTax: domain.XeroTaxCode) => onChangeReferenceField('purchaseTax', newTax)}
                            />
                        </PlainDataProvider>
                    </Field>
                </Row>
            </RowGroup>
        </div>
    );
});

TaxSection.displayName = 'TaxSection';
